export enum InsuranceListFilterKeys {
  selectedWarehouseId = 'selectedWarehouseId',
}
